"use client";
import { useMemo } from "react";
import { useHolidayQuoteBrand } from "./use-holiday-quote-brand";
import { quoteThemeCssVars } from "../quote-theme/quote-theme-css-vars";

/**
 * Hook that returns styles for pill/badge components based on primaryColorFillMode
 * @returns Object with containerStyle and textIconStyle
 */
export function usePrimaryColorStyles() {
  const { primaryColorFillMode, quoteTheme } = useHolidayQuoteBrand();
  const isDualTone = quoteTheme.config.colorSchema === "DUAL_TONE";

  return useMemo(() => {
    const isFill = primaryColorFillMode === "Fill";

    return {
      containerStyle: {
        backgroundColor: isFill
          ? quoteThemeCssVars.primary
          : isDualTone
            ? quoteThemeCssVars.secondary
            : quoteThemeCssVars.primary10,
      },
      textIconStyle: {
        color: isFill ? quoteThemeCssVars.onPrimary : quoteThemeCssVars.primary,
      },
    };
  }, [isDualTone, primaryColorFillMode]);
}
